var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-detail-page"},[_c('ProductHeader',{attrs:{"product":_vm.product,"productCategory":_vm.productCategory}}),_c('ProductOrderButtons',{attrs:{"product":_vm.product,"productCategory":_vm.productCategory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }